module.exports = __webpack_public_path__ + "img/red-cross.b5a6ff78.svg";